export const CREATE_ROLE_TITLE = "Novo Perfil";
export const EDIT_ROLE_TITLE = "Editar Perfil";
export const NAME_LABEL = "Nome";
export const NAME_PLACEHOLDER = "ex.: Gestor";
export const PERMISSIONS_LABEL = "Permissões";

export const PERMISSIONS_LOADING_MESSAGE = "Carregando permissões...";
export const PERMISSIONS_ERROR_MESSAGE = "Não foi possível carregar as permissões.";
export const PERMISSIONS_EMPTY_MESSAGE = "Nenhuma permissão cadastrada.";

/** Liga o botão Salvar, que vive no rodapé do Dialog, ao formulário do corpo. */
export const ROLE_FORM_ID = "role-form";

/** Limite da coluna `nome` de `plataforma.perfil`. */
export const NAME_MAX_LENGTH = 150;
